exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ToggleButtonWithIcon__buttonRoot___3ujU0 {\n\tpadding-right: 0!important;\n\tmargin-right: 0!important;\n\tmin-width: 0!important;\n}\n\n.ToggleButtonWithIcon__button___VCU1i {\n\tdisplay: flex;\n    padding: 0;\n    border-bottom: none;\n\tjustify-content: center;\n\twidth: inherit;\n}\n", ""]);

// exports
exports.locals = {
	"buttonRoot": "ToggleButtonWithIcon__buttonRoot___3ujU0",
	"button": "ToggleButtonWithIcon__button___VCU1i"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/ToggleButtonWithIcon.icss
// module id = 1336
// module chunks = 0